/* ============================================================
   ДИЗАЙН-ТОКЕНИ appointMe.
   Кольори узгоджені з лендінгом clean-hands-club
   (src/styles/tokens.css) — світла/золота палітра, Montserrat.
   Компоненти НЕ хардкодять кольори — беруть звідси або з теми MUI.
   ============================================================ */

export const tokens = {
  color: {
    // Поверхні
    bg: "#f4f0ea", // фон сторінки (--c-light)
    bgAlt: "#efeae2", // світліші секції (--c-light-2)
    surface: "#faf7f2", // картки / Paper (--c-card)
    dark: "#0a0a08", // хедер/футер (--c-black)

    // Текст
    ink: "#1a1a16", // основний текст на світлому (--c-ink)
    inkSoft: "#57564d", // вторинний текст (--c-ink-soft)
    onDark: "#f4f2ea", // текст на темному (--c-on-dark)
    onDarkSoft: "#b3afa4",

    // Акценти
    gold: "#c9a24a", // основний акцент (--c-gold)
    goldDeep: "#977536", // золото-текст на світлому (--c-gold-deep)
    goldLight: "#e8cf8f",
    olive: "#5e6a4e", // приглушена олива (--c-accent)

    // Лінії / стани
    line: "rgba(28, 29, 23, 0.12)", // (--c-line-light)
    lineStrong: "rgba(28, 29, 23, 0.22)",
    error: "#b3261e",
    success: "#5e6a4e",
  },
  font: {
    family: "'Montserrat', system-ui, -apple-system, 'Segoe UI', sans-serif",
  },
  radius: { sm: 8, md: 12 },
};

export default tokens;
